import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { DocumentNodeContainer } from "./containers/DocumentNodeContainer";

const routes = () => (
  <Routes>
    <Route index element={<DocumentNodeContainer />} />
    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
